import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * CSRF interceptor — double-submit cookie pattern (M-13).
 *
 * Angular's built-in HttpClientXsrfModule only adds the X-XSRF-TOKEN header
 * for same-origin / relative URLs.  In development the API runs on a
 * different port (localhost:3000 vs localhost:4200), so Angular treats it as
 * cross-origin and silently skips the header.  This custom interceptor reads
 * the XSRF-TOKEN cookie directly and attaches the header for every mutating
 * request regardless of whether the URL is relative or absolute.
 */

const SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);
const COOKIE_NAME = 'XSRF-TOKEN';
const HEADER_NAME = 'X-XSRF-TOKEN';

function readCookie(name: string): string | undefined {
  for (const cookie of document.cookie.split(';')) {
    const eqIdx = cookie.indexOf('=');
    if (eqIdx === -1) continue;
    const key = cookie.slice(0, eqIdx).trim();
    if (key === name) {
      return decodeURIComponent(cookie.slice(eqIdx + 1).trim());
    }
  }
  return undefined;
}

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (SAFE_METHODS.has(req.method)) {
      return next.handle(req);
    }

    const token = readCookie(COOKIE_NAME);
    if (!token) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { [HEADER_NAME]: token } }));
  }
}
